var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-body-2 ui-kit-text-secondary--text"},[_vm._v("\n  © 2011-"+_vm._s(new Date().getFullYear())+", ООО «МЕДРОКЕТ»\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }